import { ROLES_ADDED_API_STATUS, ROLES_REDUCED_API_STATUS } from "../PaicOrgRedesignV2.utils";

// The View Planning tabs — each lands on its saved-plans list and drills
// into a read-only mirror of the flow that created the plan.
export const VIEW_PLANNING_TAB = Object.freeze({
  REDEPLOYMENT: "redeployment",
  WORKFORCE: "workforce",
  PAIC_REDESIGN: "paic_redesign",
});

// PAIC Redesign Plan ▸ organization's role tabs, in display order. changeTypes
// are the role change_types each tab lists (REDUNDANT is a full reduction).
// The backend only returns roles_reduced + roles_increased roles, so
// groupPaicRolesByTab files any other change_type under the first tab.
export const PAIC_ROLE_TAB = Object.freeze({
  REDUCED: "reduced",
  ADDED: "added",
});

export const PAIC_ROLE_TABS = Object.freeze([
  {
    key: PAIC_ROLE_TAB.REDUCED,
    label: "Role Reduced",
    changeTypes: [ROLES_REDUCED_API_STATUS, "REDUNDANT"],
    emptyMessage: "No roles reduced in this organization.",
  },
  {
    key: PAIC_ROLE_TAB.ADDED,
    label: "Role Added",
    changeTypes: [ROLES_ADDED_API_STATUS],
    emptyMessage: "No roles added in this organization.",
  },
]);
